/**
 * 该js主要包含各种通用的方法
 */

/**
 * 去掉字符串中的空格
 * @param {string} data 待去除空格的字符串
 * @param {string} is_global 去除规则，必填。如果是g，则去掉所有空格，包含中间的
 * @returns 去除空格后的字符串
 */
 import request from '@/assets/js/request'
 import Cookies from 'js-cookie'
 import CryptoJS from 'crypto-js'
 const TokenKey = 'token_h5_gz'
 var crypto = require('crypto');
 const refreshToken = 'refreshToken';
 const buttonKey = 'button';
 let Base64 = require('js-base64').Base64;
 
 export function trim(str, is_global) {
   var result
   result = str.replace(/(^\s+)|(\s+$)/g, '')
   if (is_global.toLowerCase() == 'g') {
     result = result.replace(/\s/g, '') 
   }
   return result
 }
 
 /**
  * 获取当前日期
  * @returns yyyy-mm-dd
  */
 export function formatterDate(str) {
   var date = new Date(isEmpty(str) ? "" :str)
   var day = date.getDate() > 9 ? date.getDate() : '0' + date.getDate()
   var month = (date.getMonth() + 1) > 9 ? (date.getMonth() + 1) : '0' + (date.getMonth() + 1)
   return date.getFullYear() + '-' + month + '-' + day
 }
 /**
  * 获取当前日期
  * @returns yyyy-mm
  */
 export function formatterDateYM(str) {
   var date = new Date(isEmpty(str) ? "" :str)
   var day = date.getDate() > 9 ? date.getDate() : '0' + date.getDate()
   var month = (date.getMonth() + 1) > 9 ? (date.getMonth() + 1) : '0' + (date.getMonth() + 1)
   return date.getFullYear() + '-' + month
 }
 // 获取指定时间 yyyy-MM-dd HH:MM:SS格式
 export function formatterSureDate(str) {
   var date = new Date(str)
   var seperator1 = '-'
   var seperator2 = ':'
   var month = date.getMonth() + 1
   var strDate = date.getDate()
   var hh = date.getHours()
   var mm = date.getMinutes()
   var ss = date.getSeconds()
   if (month >= 1 && month <= 9) {
     month = '0' + month
   }
   if (strDate >= 0 && strDate <= 9) {
     strDate = '0' + strDate
   }
   if (hh >= 0 && hh <= 9) {
     hh = '0' + hh
   }
   if (mm >= 0 && mm <= 9) {
     mm = '0' + mm
   }
   if (ss >= 0 && ss <= 9) {
     ss = '0' + ss
   }
   var currentdate = date.getFullYear() + seperator1 + month + seperator1 + strDate +
         ' ' + hh + seperator2 + mm + seperator2 + ss
   return currentdate
 }
 
 /**
  * 获取当前日期时间
  * @returns yyyy-MM-dd HH:MM:SS
  */
 export function getNowFormatDate() {
   var date = new Date()
   var seperator1 = '-'
   var seperator2 = ':'
   var month = date.getMonth() + 1
   var strDate = date.getDate()
   var hh = date.getHours()
   var mm = date.getMinutes()
   var ss = date.getSeconds()
   if (month >= 1 && month <= 9) {
     month = '0' + month
   }
   if (strDate >= 0 && strDate <= 9) {
     strDate = '0' + strDate
   }
   if (hh >= 0 && hh <= 9) {
     hh = '0' + hh
   }
   if (mm >= 0 && mm <= 9) {
     mm = '0' + mm
   }
   if (ss >= 0 && ss <= 9) {
     ss = '0' + ss
   }
   var currentdate = date.getFullYear() + seperator1 + month + seperator1 + strDate +
         ' ' + hh + seperator2 + mm + seperator2 + ss
   return currentdate
 }
 
 /**
  * Created by 飞呀 on 2018/1/9.
  * 传入远程url，在本页面加载该url
  */
 export function asyncLoadJs(url) {
   var Q = require('q')
   return Q.Promise((resolve, reject) => {
     const srcArr = document.getElementsByTagName('script')
     let hasLoaded = false
     for (let i = 0; i < srcArr.length; i++) { // 判断当前js是否加载上
       hasLoaded = (srcArr[i].src == url)
     }
     if (hasLoaded) {
       resolve()
       return
     }
     const script = document.createElement('script')
     script.type = 'text/javascript'
     script.src = url
     document.body.appendChild(script)
     script.onload = () => {
       resolve()
     }
     script.onerror = () => {
       reject()
     }
   })
 }
 
 /**
  * 判断是否为空
  * @param {*} str
  */
 export function isEmpty(str) {
   if (str == null || str == '' || $.trim(str).length == 0) {
     return true
   }
   return false
 }
 
 /**
  * 是否为正常的金额格式
  * @param money
  * @returns {boolean}
  */
 export function isMoney(money) {
   var reg = /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/;
   return reg.test(money);
 }
 
 
 const encrypt = (word) => {
   if (word=='' || word === undefined) {
     return ''
   }
  word = Base64.encode(word)
  var key = CryptoJS.enc.Utf8.parse("46cc793c53dc451b");
  var srcs = CryptoJS.enc.Utf8.parse(word);
  var encrypted = CryptoJS.AES.encrypt(srcs, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
  });
  return  Base64.encode(encrypted.toString());
 }
 /**
 * 解密
 */
 const decrypt = (word) => {
  if (word=='' || word === undefined) {
    return ''
  }
  word =  Base64.decode(word)
  var key = CryptoJS.enc.Utf8.parse("46cc793c53dc451b");
  var decrypt = CryptoJS.AES.decrypt(word, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
  });
  return Base64.decode(CryptoJS.enc.Utf8.stringify(decrypt).toString());
 }
 
 
 export function getToken() {
   return Cookies.get(TokenKey)
 }
 
 export function setToken(token) {
   return Cookies.set(TokenKey, encrypt(token));
 }
 
 export function removeToken() {
   return Cookies.remove(TokenKey)
 }
 export function setRefreshToken(token) {
   return Cookies.set(refreshToken, encrypt(token));
 }
 export function getCookie(name) {
     var arr, reg = new RegExp("(^| )" + TokenKey + "=([^;]*)(;|$)");
     if(arr = document.cookie.match(reg)){
        return decrypt(arr[2]);
     }else {
       return null;
     }
   }
 
   let publicKey ='MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAhD8uvpAAyE0JpCK9Crc2IERtl/LH7/qxICWnKSCUnwPvybo0qmxxvgdQpg7xQMr6xz8p2mu4X1bhJbkHFBZ4ZGxobO2uTyPgttn/0JP3AulMEXdsEW1xpDp463II5IFeIiulk937n5pUZAKR71fAZ/Fl3pr/jX4H02SVxTyJCFccfMaUoakPXGPMcNl2PuaUMJqkwD8V1XA6Wq/NajnRwMPdaJMwAlT+b90eqJ9EPtROZ/OoPQEnKEq1LhculuHYBn3ApYpPieBHDCuQKrHJMXdWME7NNMdAfZ/9xaboBvfelo9qO4BsdQRRptbPW2VQT+9uoUZTtrckxOODFONinwIDAQAB';
   let privateKey = 'MIIEvQIBADANBgkqhkiG9w0BAQEFAASCBKcwggSjAgEAAoIBAQCEPy6+kADITQmkIr0KtzYgRG2X8sfv+rEgJacpIJSfA+/JujSqbHG+B1CmDvFAyvrHPynaa7hfVuEluQcUFnhkbGhs7a5PI+C22f/Qk/cC6UwRd2wRbXGkOnjrcgjkgV4iK6WT3fufmlRkApHvV8Bn8WXemv+NfgfTZJXFPIkIVxx8xpShqQ9cY8xw2XY+5pQwmqTAPxXVcDpar81qOdHAw91okzACVP5v3R6on0Q+1E5n86g9AScoSrUuFy6W4dgGfcClik+J4EcMK5Aqsckxd1YwTs00x0B9n/3FpugG996Wj2o7gGx1BFGm1s9bZVBP726hRlO2tyTE44MU42KfAgMBAAECggEAMSLAnXEnuURWVrPJhVe5Npf2GETOYK3GbelPiIpgbgyqZUtYEhIk2LQjFO/sV2STdMBVLqBjapj/ImLy7FXE+ZsF2aMd5q2v6oBo+fhgCKbh6oNyla8SUDChiOlfwHcIoK2S4bPSr+RJgrcpvcHe7T/V17XDSbEP+00eEKCDUaNzMTR8InO3PcbwI1sQ/jEP8gE0kRldZj0zXvOOg7l9Z1gEghE+M2iNuTwHPQNoEVIChLXsKSNyc4/kRc/ge7zvWyXDJOuGMFwxIwY593TAZSoHL82oMSQGceuf0Po36SiUoKQAGAO2G79cI465Nel1tIhZ0zu4SgEvtwPC00N8wQKBgQDCu3mDdOX594CjUb/U3nztapl8K/brkeMzOFr684CnrGb+97jPzhnVa4NFnk0EJnsO/nCYOQwTJtRnBUCHVNeNAsNuGOIII/ahkdUy/tWigDvxbQZS3O8urs4XIjQtAJHqUyxqnehzjoI7Rg8Sz8eY+xMYRUpzwnH1KEjmMl3lsQKBgQCt2t92PYWa0FT1PtvZrEFiRz5XFkpo4rIUvJ2PH3ECimRFmM5uCGHr6mgZVDks2Rl5tiuv/xVQ/li49QxU1l5eBZZigGRJtlX1zt8RsFd0B4VnZJdOmWcpGyVmlF8lN2KiWfZ41Zb7k5WfVhbvnM8R31zpbKRNvMlMteeSfKTRTwKBgEI4GlQ3llTwc1AWZpNurTDXBSaSlL76tzYdveKEl4VtPQELIE+aGHLYwqUT9cCpjUNGBufczlxc4fG+eXkLwtjyzZ5M2+BEyoOa4dMbkW5XCQtKNdJLyxIm43I+cVu0S+pRKlN/KyLQnTym0E1nVsqQ5qdkOLMwtivV7SRKkF+hAoGBAIqzTIYrrPSG8tC5tnIhsAQ1LHIUEYc+HK7Yj6cIgYNyX2766u3z+BNb7nMOs5KpHV7xzEbb7eixEp10usLQR3chZAnvvpLkSg4SXfrhwdOK0I5dPS1yy0+LHbqJ8qJhXmqB9VYPqSXKZ5s39pJxeu4aUijUCP0P+VUe5sICeQeXAoGACxV9tcRR8FgaEEm70N06RKBdCQXq+jrJcgLPUVtNGjgst5s6qTZHXS3B+DCbpsBz4bk7CKB4Ihu+7gI5wWK5S5vr9UFmHal7gTj8TWfvWzG5mwFNStq7/ayblr9q11UFLQd8J04v+xOzQw+O1r8xsj3rlyDdIEAaEMQY06ySozE='
 
   
 
   export function publicEncrypt(data) {
     let publicKeyStr = '-----BEGIN PUBLIC KEY-----\n' +publicKey+
     '\n' +
     '-----END PUBLIC KEY-----';
 
     let  encryptStr = crypto.publicEncrypt({key:publicKeyStr, padding: crypto.constants.RSA_PKCS1_PADDING}, Buffer.from(data, 'utf8'));
     let encrypted = encryptStr.toString('base64')
     return encodeURIComponent(encrypted)
 }
 
 
 export function privateDecrypt(data) {
   decodeURIComponent(data)
   let privateKeyStr = '-----BEGIN PRIVATE KEY-----\n' +privateKey+
   '\n' +
   '-----END PRIVATE KEY-----';
   let decryptStr = crypto.privateDecrypt({key:privateKeyStr, padding: crypto.constants.RSA_PKCS1_PADDING}, Buffer.from(data, 'base64'));
   let decrypted= decryptStr.toString('utf-8')
   return decrypted
 }
 
 export function IdCardValid(personnumber){
   personnumber = personnumber.toUpperCase();
   //身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X。
   if (!(/(^\d{15}$)|(^\d{17}([0-9]|X)$)/.test(personnumber))) {
     return false;
   }
   //校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。
   //下面分别分析出生日期和校验位
   var len, re;
   len = personnumber.length;
   if (len == 15) {
     re = new RegExp(/^(\d{6})(\d{2})(\d{2})(\d{2})(\d{3})$/);
     var arrSplit = personnumber.match(re);
     
     //检查生日日期是否正确
     var dtmBirth = new Date('19' + arrSplit[2] + '/' + arrSplit[3] + '/' + arrSplit[4]);
     var bGoodDay;
     bGoodDay = (dtmBirth.getFullYear() == Number(arrSplit[2])) && ((dtmBirth.getMonth() + 1) == Number(arrSplit[3])) && (dtmBirth.getDate() == Number(arrSplit[4]));
     if (!bGoodDay) {
       return false;
     }
     else {
       //将15位身份证转成18位
       //校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。
       var arrInt = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2);
       var arrCh = new Array('1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2');
       var nTemp = 0, i;
       personnumber = personnumber.substr(0, 6) + '19' + personnumber.substr(6, personnumber.length - 6);
       for (i = 0; i < 17; i++) {
         nTemp += personnumber.substr(i, 1) * arrInt[i];
       }
       personnumber += arrCh[nTemp % 11];
       return true;
     }
   }
   if (len == 18) {
     re = new RegExp(/^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X)$/);
     var arrSplit = personnumber.match(re);
     
     //检查生日日期是否正确
     var dtmBirth = new Date(arrSplit[2] + "/" + arrSplit[3] + "/" + arrSplit[4]);
     var bGoodDay;
     bGoodDay = (dtmBirth.getFullYear() == Number(arrSplit[2])) && ((dtmBirth.getMonth() + 1) == Number(arrSplit[3])) && (dtmBirth.getDate() == Number(arrSplit[4]));
     if (!bGoodDay) {
       return false;
     } else {
       //检验18位身份证的校验码是否正确。
       //校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。
       var valnum;
       var arrInt = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2);
       var arrCh = new Array('1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2');
       var nTemp = 0, i;
       for (i = 0; i < 17; i++) {
         nTemp += personnumber.substr(i, 1) * arrInt[i];
       }
       valnum = arrCh[nTemp % 11];
       if (valnum != personnumber.substr(17, 1)) {
         return false;
       }
       return true;
     }
   }
   return false;
 }
 
 export function getIsApp() {
     var ua = navigator.userAgent.toLowerCase();
     if (ua.match(/isapp/i) == "isapp") {
         return true;
     }
     return false;
 }

 // 存储隐私授权
export function savePrivacy(data) {
  request({
      baseURL: process.env.VUE_APP_PAY_URL,
      url: '/privacy_authorization_storage',
      method: 'post',
      data:data
  })
}
